import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Ranking from "./components/Ranking";
import RecommendGrid from "./components/RecommendGrid";
import Guide from "./components/Guide";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [query, setQuery] = useState("");

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero query={query} onSearch={setQuery} />
        <Featured />
        <Ranking />
        <RecommendGrid query={query} onSearch={setQuery} />
        <Guide />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}